import { Reveal } from "./Reveal";

const clinics = [
  "Apex Spine & Rehab",
  "Motion MSK Clinic",
  "Northside Physio",
  "Restore Chiropractic",
  "Vital Sports Therapy",
];

export function TrustedBy() {
  return (
    <section className="border-y border-slate-100 bg-white py-14">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="text-center text-sm font-medium text-slate-500">
            Built for chiropractic, physiotherapy, and massage therapy documentation — trusted by
            modern rehabilitation clinics and MSK professionals.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-10 gap-y-6">
            {clinics.map((name) => (
              <span
                key={name}
                className="text-base font-semibold tracking-tight text-slate-400 transition-colors hover:text-slate-600"
              >
                {name}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
